import { formatPhone } from '#/shared/lib/format'
import type { CustomerSummary } from '#/shared/api/generated/communication/models'

/**
 * Resolved counterparty summary as the panel needs it: a display title plus a
 * formatted phone number. Every row/thread/favorite passes through here so the
 * "name, else company, else formatted number" fallback lives in one place.
 */
export function counterpartyTitle(
  customer: CustomerSummary | null | undefined,
  number: string | null | undefined,
): string {
  return customer?.name ?? customer?.company ?? formatPhone(number)
}

/**
 * Secondary detail line for a contact: formatted phone, optionally followed by
 * the company type (e.g. "Dealer"). Used by the favorites contact rows.
 */
export function counterpartyDetail(
  customer: CustomerSummary | null | undefined,
  number: string | null | undefined,
): string {
  const phone = formatPhone(number)
  const type = customer?.company_type
  if (!type) return phone
  const typeLabel = type.charAt(0).toUpperCase() + type.slice(1)
  return phone ? `${phone} · ${typeLabel}` : typeLabel
}
